var _Path, _Text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { Path, Text, TSpan } from "react-native-svg";
function SvgAgeLimit(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30 30"
  }, props), _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    d: "M15 2.5c6.89 0 12.5 5.61 12.5 12.5S21.89 27.5 15 27.5 2.5 21.89 2.5 15 8.11 2.5 15 2.5M15 0C6.72 0 0 6.72 0 15s6.72 15 15 15 15-6.72 15-15S23.28 0 15 0z",
    fill: "#e5385e"
  })), _Text || (_Text = /*#__PURE__*/React.createElement(Text, {
    transform: "translate(5.24 19.52)",
    fontFamily: "MyriadPro-Regular,'Myriad Pro'",
    fontSize: 12.5
  }, /*#__PURE__*/React.createElement(TSpan, {
    x: 0,
    y: 0
  }, "18+"))));
}
export default SvgAgeLimit;